const _ = require('lodash');
const { parseFullName } = require('parse-full-name');

const getFirstName = user => {
  const { name } = user || {};
  if (!name) return '';

  // Clean up name
  let finalName = name.trim();
  finalName = finalName.split('@').join('');
  finalName = finalName.split('Dr. ').join('');
  finalName = _.first(finalName.split('('));
  finalName = _.first(finalName.split('['));
  finalName = _.first(finalName.split(','));
  finalName = _.first(finalName.split(' - '));
  finalName = _.first(finalName.split('/'));
  finalName = _.first(finalName.split('|'));
  finalName = _.first(finalName.split(':'));
  finalName = finalName.trim();

  // Edge Cases
  if (finalName.includes('The ')) return finalName;
  if (finalName.includes(' & ')) return finalName;
  if (finalName.includes("'s")) return finalName;
  if (finalName.includes('Skincare')) return finalName;
  if (finalName.includes('Beauty')) return finalName;
  if (finalName.includes('Makeup')) return finalName;
  if (finalName.includes('Fashion')) return finalName;
  if (finalName.includes('Aging')) return finalName;

  // Leverage Library
  try {
    let resp = parseFullName(finalName);
    const parts = finalName.trim().split(' ');
    if (parts.length <= 3) return resp.first || resp.last;
  } catch {
    return finalName;
  }

  return finalName;
};

const getLastName = user => {
  if (!user.name) return '';
  const cleanName = user.name
    .split('Dr.')
    .join('')
    .trim();
  const nameParts = cleanName.split(' ');
  return nameParts.slice(1).join(' ') || '';
};

module.exports = {
  getFirstName,
  getLastName
};
